import Text from 'components/Text';
import Sidebar from 'components/layout/Sidebar';
import reportActions from 'features/report/services/actions';
import reportSelectors from 'features/report/services/selectors';
import { IParamsReportSalaryStaff } from 'features/report/services/types/review';
import { sumBy } from 'lodash';
import { Fragment, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import { formatCurrency } from 'utils/formatCurrency';
import PayrollReceiptWrapper from './PayrollReceiptWrapper';
import PrintHeader from './PrintHeader';
import StaffPayrollDetail from './StaffPayrollDetail';
import { ContainerStyled, DividerSlit, ReportPayrollCaption2HighLightRow, ReportPayrollCaption3Row } from './components';
import usePayrollTemplate from './templates';
import moment from 'moment';


const StaffPayrollYearlyPrint = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const params = reportSelectors.getYearlyPayrollReportParams();
  const navigate = useNavigate();
  const onBack = () => navigate(-1);

  const _params = useMemo(() => {
    const date = moment().set({ year: params?.year });
    const startDate = date.clone().startOf('year');
    const endDate = date.endOf('year');
    return {
      startDate: startDate.format('MM-DD-YYYY'),
      endDate: endDate.format('MM-DD-YYYY'),
    };
  }, [params]);

  const onPrint = useReactToPrint({
    content: () => divRef.current,
    copyStyles: true,
  });

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <ContainerStyled>
        <PrintHeader onBack={onBack} onPrint={onPrint} />
        <div ref={divRef}>
          <StaffPayrollYearlyPrintUI params={_params} />
        </div>
      </ContainerStyled >
    </div >
  );
};

export default StaffPayrollYearlyPrint;
type Props = {
  params: IParamsReportSalaryStaff;
};

const StaffPayrollYearlyPrintUI = ({ params }: Props) => {
  console.log('StaffPayrollYearlyPrintUI 1', params);
  const allSetting = shopSelectors.data.allSetting();
  const staffPayrollData = reportSelectors.getYearlyPayrollReport();

  const cashLabel = allSetting?.labelSalaryCashOrBonus || 'Cash';
  const singleDate = params?.startDate == params?.endDate;
  const singleStaff = !!params.staffId;
  // const staffPayrollData = reportSelectors.getStaffPayrollData();

  const template = usePayrollTemplate(params);
  console.log('StaffPayrollYearlyPrintUI template', staffPayrollData);


  const calculations = useMemo(() => {
    const totalSalary = sumBy(staffPayrollData, o => o.totalSalary || 0);
    const totalCash = sumBy(staffPayrollData, o => o.totalCash || 0);
    const totalCheck = sumBy(staffPayrollData, o => o.totalCheck || 0);
    return ({
      totalSalary,
      totalCash,
      totalCheck,
    });
  }, [staffPayrollData]);
  return (
    <PayrollReceiptWrapper params={params}>
      {!singleStaff && <>
        <ReportPayrollCaption2HighLightRow
          label='Employee Salaries'
          amount={formatCurrency(calculations?.totalSalary)}
        />
        <Text mb={0.25} />
        <ReportPayrollCaption3Row
          label={`Total ${cashLabel}`}
          amount={formatCurrency(calculations?.totalCash)}
        />
        <ReportPayrollCaption3Row
          label={'Total Check'}
          amount={formatCurrency(calculations?.totalCheck)}
        />
        <Text mb={0.5} />
      </>}
      {staffPayrollData?.map((staff, i) => (
        <Fragment key={staff.staffId}>
          <StaffPayrollDetail
            key={staff.staffId}
            data={staff}
            cashLabel={allSetting?.labelSalaryCashOrBonus || 'Cash'}
            singleDate={singleDate}
            singleStaff={singleStaff}
            fields={template}
            yearlyReport
          />
          {((staffPayrollData?.length - 1) !== i) && <DividerSlit />}
        </Fragment>
      ))}
    </PayrollReceiptWrapper>
  );
};